// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/GenderPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/** 성별 */
export enum GenderPayload {
  GENDER_UNKNOWN = 0,
  /** GENDER_MALE - 남 */
  GENDER_MALE = 1,
  /** GENDER_FEMALE - 여 */
  GENDER_FEMALE = 2,
  /** GENDER_ANY - 남녀 공통 — 선수에게는 쓰지 않고, 성별을 나누지 않는 체급을 표기할 때만 쓴다 */
  GENDER_ANY = 3,
  UNRECOGNIZED = -1,
}

export function genderPayloadFromJSON(object: any): GenderPayload {
  switch (object) {
    case 0:
    case "GENDER_UNKNOWN":
      return GenderPayload.GENDER_UNKNOWN;
    case 1:
    case "GENDER_MALE":
      return GenderPayload.GENDER_MALE;
    case 2:
    case "GENDER_FEMALE":
      return GenderPayload.GENDER_FEMALE;
    case 3:
    case "GENDER_ANY":
      return GenderPayload.GENDER_ANY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GenderPayload.UNRECOGNIZED;
  }
}

export function genderPayloadToJSON(object: GenderPayload): string {
  switch (object) {
    case GenderPayload.GENDER_UNKNOWN:
      return "GENDER_UNKNOWN";
    case GenderPayload.GENDER_MALE:
      return "GENDER_MALE";
    case GenderPayload.GENDER_FEMALE:
      return "GENDER_FEMALE";
    case GenderPayload.GENDER_ANY:
      return "GENDER_ANY";
    case GenderPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
